import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { List } from '@styled-icons/evaicons-solid/List';

//Actions
import { pesquisaCodigoPromocional as pesquisa, codigoselecionado, zerapesquisa } from '../../../../actions/produto/codigoPromocional';

//Compoments
import DashboardMenu from '../../components/dashboard/DashboardMenu';
import Header from '../../components/layouts/header';
import Body from '../../components/layouts/body';
import FormCodigoPromocional from '../../components/forms/FormCodigoPromocional';
import ListaCadastro from '../../components/forms/ListaCadastro';


//Helpers
import { TelaModalLivre } from '../../../../helpers/TelaModal';

//Utils
import { getEvento } from '../../../../utils/eventosession';

class CodigosPromocionais extends React.Component {

    state = {
        pesquisamodal: false
    }

    handleSubmit = (form) => {
        const evento = getEvento();
        const dados = {
            ...form,
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            whereInStatusPedido: JSON.stringify(['1','2','6'])            
        }
        this.props.pesquisa(dados);
    }

    handleCodigoSelecionado = (cadastro = {}) => {
        this.props.codigoselecionado(cadastro);
        this.handleCloseModal();
    }

    handleCloseModal = () => {
        this.setState({
            pesquisamodal: !this.state.pesquisamodal?true:false
        })
    }
    
    render() {
        
        return (
            <>
            <TelaModalLivre show={this.state.pesquisamodal} handleCloseModal={this.handleCloseModal} titulo="Pesquisa Codigos Cadastrados">
                <ListaCadastro {...this.props} 
                cadastroselecionado={this.handleCodigoSelecionado} 
                pesquisa={this.props.pesquisa}                 
                handleSubmit={this.handleSubmit}
                handleCloseModal={this.handleCloseModal}
                handleZeraPesquisa={this.props.zerapesquisa}
                {...{
                    col0campo: 'codigo',
                    col1campo: 'descricao',
                    col2campo: 'gratuito',                    
                    col0desc: 'Código',
                    col1desc: 'Descrição',
                    col2desc: 'Gratuito',
                    campopesquisa: 'descricao',
                    placeholder: 'Ex. meia entrada...'
                }}
                />
            </TelaModalLivre>
            <DashboardMenu />
            <Header titulo="Códigos Promocionais" subtitulo="Cadastro" descricao="" />
            <Body>
                <Button variant="outline-info" className="mb-4" size="lg" block onClick={this.handleCloseModal}>
                    <List size="30" />
                    Codigos Cadastrados
                </Button>
                <FormCodigoPromocional  />
            </Body>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        cadastros: state.reducerPesquisaCodigoPromocional
    }
}

export default connect(mapStateToProps,{codigoselecionado,pesquisa, zerapesquisa})(withRouter(CodigosPromocionais));